import type { IAlbum } from 'reactApp/modules/albums/albums.types';
import { FamilyContentCategoryType } from 'reactApp/modules/familyContent/familyContent.types';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getFamilyContentState = (state: RootState) => state.familyContent;

export const getFamilyContentCategory = (state: RootState): FamilyContentCategoryType => getFamilyContentState(state).currentCategory;
export const getFamilyContentCategories = createSelector(getFamilyContentState, (familyContent) => familyContent.categories);

export const getFamilyContentList = (state: RootState) => getFamilyContentState(state).list;
export const getFamilyContentAlbumsIds = (state: RootState) => {
    const category = getFamilyContentCategoryById(state, FamilyContentCategoryType.albums);

    return category?.childs || [];
};

export const getFamilyContentCategoryById = createSelector(
    getFamilyContentCategories,
    (state: RootState, category: FamilyContentCategoryType) => category,
    (categories, category) => categories.find((item) => item.id === category)
);

export const getFamilyFoldersListById = createSelector(
    getFamilyContentList,
    (state, id) => id,
    (list, id) => list[id]
);

export const getCurrentFamilyContentCategory = createSelector(
    getFamilyContentCategory,
    (state: RootState) => state,
    (currentCategory, state) => getFamilyContentCategoryById(state, currentCategory)
);

export const getFamilyContentAlbumsList = createSelector(
    getFamilyContentList,
    getFamilyContentAlbumsIds,
    (list, ids) => (ids.map((id) => list[id]).filter(Boolean) || []) as Array<IAlbum>
);
